import { connect } from "react-redux";
import { useLocale } from "@lib/i18n/navigation-pages-router";
import { defaultLocale } from "@lib/i18n/config";
import { useCurrentUser } from "@hooks/use-current-user";
import { setCatalogLastScrollY } from "@actions/navigation-actions";
import QuickAddToCloset from "@components/core/QuickAddToCloset";
import catalogContexts from "@utils/constants/catalogContexts";
import { productClickedEvent } from "@utils/events/product-events";
import ProductLike from "../Product/Shared/ProductLike";
import CatalogProductStickers from "./CatalogProductStickers";
import ProductPicturesCarousel from "../Product/Shared/ProductPicturesCarousel";
import ProductSalesRibbon from "../Product/Shared/ProductSalesRibbon";

const CatalogProduct = ({
  setLastScrollY,
  context,
  product = {},
  indexName,
  position,
  onProductRemovedFromUserList,
}) => {
  const user = useCurrentUser();
  const locale = useLocale();

  const algoliaObject = {
    query_id: product?.__queryID,
    index_name: indexName,
  };

  const dataFromAlgolia = {
    algolia: algoliaObject,
    position: product.__position,
    objectID: product.objectID,
    userToken: user?.uid,
  };

  const isProductPresent = () => {
    if (Object.keys(product).length > 0) return true;

    return false;
  };

  function onProductClicked() {
    const { scrollY } = window;
    setLastScrollY(scrollY);

    if (context === catalogContexts.swap) {
      productClickedEvent(dataFromAlgolia, "productClicked");
    }
  }

  const productName = () => {
    if (!product.id) return "...";

    const name = locale === defaultLocale ? "name" : `name_${locale?.toLowerCase()}`;
    return product[name];
  };

  return (
    <div className="catalog-product">
      <div className="catalog-product-image">
        {isProductPresent && (
          <ProductPicturesCarousel
            algolia={algoliaObject}
            product={product}
            onClick={onProductClicked}
            onContextMenu={onProductClicked}
            onAuxClick={onProductClicked}
            position={position}
            context={context}
          />
        )}
        <CatalogProductStickers
          product={product}
          context={context}
        />
        <ProductSalesRibbon
          product={product}
          context={context}
        />
      </div>
      <ProductLike
        product={product}
        className="catalog-product-like"
        isOnUserList={context === catalogContexts.userlist}
        onProductRemovedFromUserList={onProductRemovedFromUserList}
      />

      <div className="catalog-product-infos py-2 d-flex justify-content-center text-center">
        <div className="d-flex flex-column w-100 px-2">
          <h6 className="mb-0 catalog-product-name">{productName()}</h6>
          <p className="mb-0 text-gray catalog-product-brand">{product.brand?.name || "..."}</p>
        </div>
      </div>

      <QuickAddToCloset
        context={context}
        productSelected={product}
        dataFromAlgolia={dataFromAlgolia}
      />
    </div>
  );
};

export default connect(null, { setLastScrollY: setCatalogLastScrollY })(CatalogProduct);
